export default __webpack_public_path__ + "static/media/yellow-aircraft.b1ba0970.png";